import { render, staticRenderFns } from "./DocBlocks.vue?vue&type=template&id=32c39b06&scoped=true"
import script from "./DocBlocks.vue?vue&type=script&lang=js"
export * from "./DocBlocks.vue?vue&type=script&lang=js"
import style0 from "./DocBlocks.vue?vue&type=style&index=0&id=32c39b06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c39b06",
  null
  
)

export default component.exports